<template>
  <div class="event_times">
    <div class="event_times_top">
      <div class="date">{{formattedDate}}</div>
    </div>
    <div class="event_times_bottom">
      <div class="time_from">{{formattedTimeStart}}</div>
      <div class="time_divider">-</div>
      <div class="time_to">{{formattedTimeEnd}}</div>
      <div class="duration">{{time.duration}} мин</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EventModalTimes",
  computed: {
    formattedDate() {
      const dateObj = new Date(this.date)
      const locale = 'ru-RU'

      const dayMonth = dateObj.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long'
      })
      const weekday = dateObj.toLocaleString(locale, { weekday: 'long' })

      return `${dayMonth}, ${weekday}`
    },
    formattedTimeStart() {
      return this.time.start?.slice(0, 5) || ''
    },
    formattedTimeEnd() {
      return this.time.end?.slice(0, 5) || ''
    }
  },
  props: {
    time: {
      type: Object,
      default: function () {
        return {}
      }
    },
    date: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
}
</script>

